// extracted by mini-css-extract-plugin
export default {"container":"card-layout_container__ZY3cd"};